import React from "react";

import filtersIcon from "./assets/navigation/normalized/filters.png";
import gamesIcon from "./assets/navigation/normalized/games.png";
import injuriesIcon from "./assets/navigation/normalized/injuries.png";
import lineupGeneratorIcon from "./assets/navigation/normalized/lineup-generator.png";
import myPlaysIcon from "./assets/navigation/normalized/my-plays.png";
import patternIntelligenceIcon from "./assets/navigation/normalized/pattern-intelligence.png";
import playerTaxonomyIcon from "./assets/navigation/normalized/player-taxonomy.png";

export const PWG_NAVIGATION_ICONS = Object.freeze({
  filters: filtersIcon,
  games: gamesIcon,
  injuries: injuriesIcon,
  lineup: lineupGeneratorIcon,
  myplays: myPlaysIcon,
  pattern_intelligence: patternIntelligenceIcon,
  taxonomy: playerTaxonomyIcon,
});

export default function NavigationIcon({ icon, testId, contrastOnLight = false }) {
  if (icon === "discord") {
    return (
      <span aria-hidden="true" data-navigation-icon="discord" data-testid={testId} style={{ width: 28, height: 28, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
        <svg viewBox="0 0 24 24" width="28" height="28" role="presentation">
          <path fill="#5865F2" d="M19.6 5.3A18.2 18.2 0 0 0 15.2 4l-.5 1.1a16 16 0 0 0-5.4 0L8.8 4a18.5 18.5 0 0 0-4.4 1.3C1.6 9.5.9 13.6 1.3 17.6a18 18 0 0 0 5.4 2.7l1.3-1.8a11.8 11.8 0 0 1-2.1-1l.5-.4c3.8 1.8 7.9 1.8 11.7 0l.5.4c-.7.4-1.4.7-2.1 1l1.3 1.8a18 18 0 0 0 5.4-2.7c.5-4.7-.8-8.8-3.6-12.3ZM8.7 15.2c-1.2 0-2.1-1.1-2.1-2.4s.9-2.4 2.1-2.4 2.1 1.1 2.1 2.4-.9 2.4-2.1 2.4Zm6.6 0c-1.2 0-2.1-1.1-2.1-2.4s.9-2.4 2.1-2.4 2.1 1.1 2.1 2.4-.9 2.4-2.1 2.4Z" />
        </svg>
      </span>
    );
  }
  const source = PWG_NAVIGATION_ICONS[icon];
  if (!source) return null;

  return (
    <span
      aria-hidden="true"
      data-navigation-icon={icon}
      data-testid={testId}
      style={{
        width: 28,
        height: 28,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "0 0 28px",
        overflow: "hidden",
        background: "transparent",
      }}
    >
      <img
        src={source}
        alt=""
        draggable={false}
        style={{
          width: "100%",
          height: "100%",
          display: "block",
          objectFit: "contain",
          background: "transparent",
          filter: contrastOnLight ? "invert(1)" : undefined,
        }}
      />
    </span>
  );
}
